/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DisbandImpactDto as FeatureEnsemblesDisbandImpactDto } from '../../models/feature/ensembles/disband-impact-dto';

export interface GetImpact$Params {
  ensembleId: number;
}

export function getImpact(http: HttpClient, rootUrl: string, params: GetImpact$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureEnsemblesDisbandImpactDto>> {
  const rb = new RequestBuilder(rootUrl, getImpact.PATH, 'get');
  if (params) {
    rb.path('ensembleId', params.ensembleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureEnsemblesDisbandImpactDto>;
    })
  );
}

getImpact.PATH = '/disband-ensemble-dialog/{ensembleId}';

